import LoginCollection from "@components/User/LoginCollection";
import { useColorsQuery } from "@graphql/api";
import { Popover } from "@headlessui/react";
import Dialog from "@hudson/ui/components/Dialogs/Simple";
import Button from "@hudson/ui/components/FormFields/Button";
import { camelToSnakeCase } from "@hudson/ui/lib/utils";
import useConfig from "@lib/use_config";
import useContent from "@lib/use_content";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

export default function NotLoggedIn(): JSX.Element | null {
  const searchParams = useSearchParams();

  const [showLogin, setShowLogin] = useState(false);
  const [dialogPage, setDialogPage] = useState("loginOrCreate");
  const [maxWidthClass, setMaxWidthClass] = useState("max-w-md");
  const { data: cData } = useColorsQuery();
  const { data } = useContent(["beHeaderProfileButton"]);
  const { data: cfgData } = useConfig(["hideUserProfileActions"]);

  // If we've been directed to open the login popup via url param then do so.
  useEffect(() => {
    if (searchParams?.get("open_login")) setShowLogin(true);
  }, []);

  function pageChanged(page: string) {
    if (page == "profile") setMaxWidthClass("max-w-4xl");
    else setMaxWidthClass("max-w-md");
  }

  function showLoginDialog() {
    setDialogPage("loginOrCreate");
    setShowLogin(true);
  }

  return cfgData?.config.hideUserProfileActions ? null : (
    <>
      <Dialog
        maxWidthClass={maxWidthClass}
        show={showLogin}
        onHide={() => setShowLogin(false)}
        pagePath={`/user/${camelToSnakeCase(dialogPage)}`}
      >
        <LoginCollection onPageChange={(page) => pageChanged(page)} />
      </Dialog>

      <Popover className="relative">
        {({ open }) => (
          <>
            <Button
              className="text-lg"
              textColorClass="text-gray-500"
              onClick={showLoginDialog}
              textColorClass="text-gray-500"
              asLink
            >
              <div className="flex p-1 space-x-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke={cData?.colors.primaryColor}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                </svg>
                <span>{data?.content.beHeaderProfileButton}</span>
              </div>
            </Button>
          </>
        )}
      </Popover>
    </>
  );
}
